module.exports = __webpack_public_path__ + "static/media/5.0a1bd897.jpg";